import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyAiEYxRlbo58ft1TfxcSq5OIsjEZXbtlEI',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'cosa-nostra-casino.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'cosa-nostra-casino',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'cosa-nostra-casino.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '311326562498',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:311326562498:web:66fb6cc264701e8c81435b',
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Auth instance
export const auth = getAuth(app)

// Firestore instance
export const db = getFirestore(app)

export default app

// Check if Firebase is configured with real values
export function isFirebaseConfigured(): boolean {
  return firebaseConfig.apiKey !== 'TU_API_KEY_AQUI'
}
